export enum ErrorStatesOptions {
    NotAuthorized,
    NotLogged,
    UnexpectedError
}
